import { Attribute, SearchHandler, SearchResult } from '@/components/Form/AudienceTargeting/Audience/interfaces'
import fetch from '@/utilities/fetch'

interface ApiResponse {
  itemsPerPage: number
  resources: {
    count: number
    resourceType: string
    term: string
    termId: null | string
    display_name?: string
  }[]
  startIndex: number
}
const searchAggregate = async (filter: string, count: number, groupBy: string): Promise<ApiResponse> => {
  return await fetch(
    '/organizations/:organizationId/users/aggregate',
    { method: 'POST', body: { count, filter, groupBy, spaceId: ':spaceId' } },
    { service: 'tenant' }
  )
}

class AggregateSearch implements SearchHandler {
  private attribute: Attribute

  constructor(attr: Attribute) {
    this.attribute = attr
  }

  async search(searchTerm: string): Promise<SearchResult[]> {
    let filter = ''
    if (this.attribute.type === 'complex') {
      if (['emails', 'manager', 'phoneNumbers'].includes(this.attribute.scimAttributeName)) {
        filter = `${this.attribute.urn}.value co ${searchTerm}`
      } else if (['groups'].includes(this.attribute.scimAttributeName)) {
        // Groups is slightly different from the backend where we need to use `display` instead of `value`
        filter = `${this.attribute.urn}.display co ${searchTerm}`
      }
    } else {
      filter = `${this.attribute.urn} co ${searchTerm}`
    }

    const results = await searchAggregate(filter, 10, this.attribute.urn)

    return results.resources.map(result => ({
      id: String(result.termId || result.term),
      count: result.count,
      resourceType: result.resourceType,
      term: result.term || result.termId,
      displayValue: result.display_name, // Display value primarily used for groups type
      type: 'group',
      subtitle: String(result.count),
      termId: result.termId || result.term
    }))
  }

  getAttribute(): Attribute {
    return this.attribute
  }

  getValue(searchResult: SearchResult) {
    return {
      displayValue: `${searchResult.displayValue || searchResult.term}`,
      value: `${searchResult.termId || searchResult.term}`
    }
  }
}

export default AggregateSearch
